import { useEffect } from 'react';

import { enableI18nDetection } from 'scripts/i18n/i18n';
import useIsFeatureEnabled from 'components/hooks/use_is_feature_enabled';

export default function I18nFeatureGate() {
  const isFeatureEnabled = useIsFeatureEnabled();
  const enabled = isFeatureEnabled('i18n');

  useEffect(() => {
    if (enabled) {
      enableI18nDetection();
    }
  }, [enabled]);

  return null;
}
